"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".interviewMulti-container {\n  display: flex;\n  flex-direction: column;\n  gap: 48px; }\n";
  const fileName = "InterviewMulti_InterviewMulti";
  const element = document.querySelector("style[data-sass-component='InterviewMulti_InterviewMulti']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const QuestionAnswerMulti = _ref => {
  let {
    item,
    lang
  } = _ref;
  const {
    question_multi,
    answer_multi
  } = item;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-margin-01-bottom sia-text-05",
    lang: lang,
    dangerouslySetInnerHTML: {
      __html: question_multi[0]?.replace('<p>', '')?.replace('</p>', '')
    }
  }), answer_multi?.map((answer, index) => {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "sia-text-04"
    }, answer.interviewed_multi[0], ": "), /*#__PURE__*/_react.default.createElement("span", {
      className: "sia-text-10",
      lang: lang,
      dangerouslySetInnerHTML: {
        __html: answer?.answer_multi_multi[0]?.replace('<p>', '')?.replace('</p>', '')
      }
    }));
  }));
};
const InterviewMulti = _ref2 => {
  let {
    item,
    lang
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "interviewMulti-container sia-padding-03-bottom sia-padding-03-right"
  }, item?.question_answer_multi?.map((el, index) => {
    return /*#__PURE__*/_react.default.createElement(QuestionAnswerMulti, {
      key: index,
      item: el,
      lang: lang,
      interviewed: item.interviewed
    });
  }));
};
InterviewMulti.propTypes = {
  item: _propTypes.default.object.isRequired,
  lang: _propTypes.default.string.isRequired
};
InterviewMulti.defaultProps = {};
var _default = exports.default = InterviewMulti;